/** @jsxImportSource @emotion/react */
"use client";

import { type Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/next";
import { IconButton, InfoIcon, spacing, useDialog } from "@packages/ui";

const iconStyles: Interpolation = {
  padding: spacing.xs,
};

export const StripeInfoDialog = () => {
  const t = useTranslations();

  const dialogStripeInfo = useDialog({
    description: () => t("giving_stripe_description"),
    showCloseButton: true,
    size: "m",
    title: () => t("giving_what_is_stripe"),
  });

  return (
    <IconButton
      asChild
      onClick={async (e) => {
        e.stopPropagation();
        await dialogStripeInfo.show();
      }}
      icon={<InfoIcon size={20} />}
      size="s"
      variant="transparentNeutral"
      css={iconStyles}
    >
      <span />
    </IconButton>
  );
};
